import { Users } from "lucide-react";

import { Card, CardContent } from "@/components/ui/card";
import { DataTable } from "@/components/ui/data-table";
import type { UserAction } from "@/features/users/components/UserActionsDialog";
import { createUsersColumns } from "@/features/users/components/users-columns";
import type { User as UserType } from "@/features/users/schemas/user";

interface UsersTableProps {
  users: UserType[];
  isLoading: boolean;
  onEdit: (user: UserType) => void;
  onView: (user: UserType) => void;
  onAction: (user: UserType, action: UserAction) => void;
  onViewImagings?: (user: UserType) => void;
  currentUser?: UserType | null;
}

export function UsersTable({
  users,
  isLoading,
  onEdit,
  onView,
  onAction,
  onViewImagings,
  currentUser,
}: UsersTableProps) {
  const columns = createUsersColumns({
    onEdit,
    onView,
    onAction,
    onViewImagings,
    currentUser,
  });

  if (!isLoading && users.length === 0) {
    return (
      <Card>
        <CardContent className="p-6">
          <div className="flex flex-col items-center justify-center py-8">
            <Users className="h-12 w-12 text-muted-foreground mb-4" />
            <h3 className="text-lg font-medium mb-2">No hay usuarios</h3>
            <p className="text-muted-foreground text-center">
              No se encontraron usuarios que coincidan con los filtros aplicados.
            </p>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="m-0 p-0">
      <CardContent className="p-0 m-0">
        <DataTable
          columns={columns}
          data={users}
          searchKey="name"
          searchPlaceholder="Buscar usuarios..."
          showPagination={false}
          showSearch={false}
          showFilters={false}
          loading={isLoading}
          emptyMessage="No se encontraron usuarios que coincidan con los filtros aplicados."
          onRowClick={(row) => onView(row.original)}
        />
      </CardContent>
    </Card>
  );
}
